import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalJerarquiaDef } from "./PersonalJerarquiaDef";

export class PersonalJerarquia extends Entity<PersonalJerarquiaDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalJerarquiaDef(), parentKeys);
        this.Title = "Personal Jerarquia";
    }
}